module.exports = __webpack_public_path__ + "static/media/icone-produtividade.751a2c71.png";